import { LoanUsesDefault, LoanUsesCarousel } from '.';
import {
  LoanUsesSliceCarouselPrimary,
  LoanUsesSliceDefaultPrimary,
  Simplify,
} from '../../../../prismicio-types';
import { LoanUsesVariation } from '../types';

interface LoanUsesInnerProps {
  data:
    | Simplify<LoanUsesSliceDefaultPrimary>
    | Simplify<LoanUsesSliceCarouselPrimary>;
  variation: LoanUsesVariation;
}

export const LoanUsesInner = ({ data, variation }: LoanUsesInnerProps) => {
  switch (variation) {
    case LoanUsesVariation.Default:
      return (
        <LoanUsesDefault data={data as Simplify<LoanUsesSliceDefaultPrimary>} />
      );
    case LoanUsesVariation.Carousel:
      return (
        <LoanUsesCarousel
          data={data as Simplify<LoanUsesSliceCarouselPrimary>}
        />
      );

    default:
      break;
  }
  return null;
};
